"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ActivityDefinition = exports.ActivityDefinitionStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_ContactDetail_1 = require("./RTTI_ContactDetail");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_UsageContext_1 = require("./RTTI_UsageContext");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_RelatedArtifact_1 = require("./RTTI_RelatedArtifact");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_Timing_1 = require("./RTTI_Timing");
var RTTI_Age_1 = require("./RTTI_Age");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_Duration_1 = require("./RTTI_Duration");
var RTTI_ActivityDefinition_Participant_1 = require("./RTTI_ActivityDefinition_Participant");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Dosage_1 = require("./RTTI_Dosage");
var RTTI_ActivityDefinition_DynamicValue_1 = require("./RTTI_ActivityDefinition_DynamicValue");
var ActivityDefinitionStatusKind;
(function (ActivityDefinitionStatusKind) {
    ActivityDefinitionStatusKind["_draft"] = "draft";
    ActivityDefinitionStatusKind["_active"] = "active";
    ActivityDefinitionStatusKind["_retired"] = "retired";
    ActivityDefinitionStatusKind["_unknown"] = "unknown";
})(ActivityDefinitionStatusKind = exports.ActivityDefinitionStatusKind || (exports.ActivityDefinitionStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ActivityDefinition = t.recursion('IActivityDefinition', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('ActivityDefinition')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            url: RTTI_uri_1.RTTI_uri,
            _url: RTTI_Element_1.RTTI_Element,
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            version: t.string,
            _version: RTTI_Element_1.RTTI_Element,
            name: t.string,
            _name: RTTI_Element_1.RTTI_Element,
            title: t.string,
            _title: RTTI_Element_1.RTTI_Element,
            subtitle: t.string,
            _subtitle: RTTI_Element_1.RTTI_Element,
            status: (0, EnumType_1.createEnumType)(ActivityDefinitionStatusKind, 'ActivityDefinitionStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            experimental: t.boolean,
            _experimental: RTTI_Element_1.RTTI_Element,
            subjectCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            subjectReference: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            publisher: t.string,
            _publisher: RTTI_Element_1.RTTI_Element,
            contact: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            description: RTTI_markdown_1.RTTI_markdown,
            _description: RTTI_Element_1.RTTI_Element,
            useContext: t.array(RTTI_UsageContext_1.RTTI_UsageContext),
            jurisdiction: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            purpose: RTTI_markdown_1.RTTI_markdown,
            _purpose: RTTI_Element_1.RTTI_Element,
            usage: t.string,
            _usage: RTTI_Element_1.RTTI_Element,
            copyright: RTTI_markdown_1.RTTI_markdown,
            _copyright: RTTI_Element_1.RTTI_Element,
            approvalDate: RTTI_date_1.RTTI_date,
            _approvalDate: RTTI_Element_1.RTTI_Element,
            lastReviewDate: RTTI_date_1.RTTI_date,
            _lastReviewDate: RTTI_Element_1.RTTI_Element,
            effectivePeriod: RTTI_Period_1.RTTI_Period,
            topic: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            author: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            editor: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            reviewer: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            endorser: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            relatedArtifact: t.array(RTTI_RelatedArtifact_1.RTTI_RelatedArtifact),
            library: t.array(RTTI_canonical_1.RTTI_canonical),
            kind: RTTI_code_1.RTTI_code,
            _kind: RTTI_Element_1.RTTI_Element,
            profile: RTTI_canonical_1.RTTI_canonical,
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            intent: RTTI_code_1.RTTI_code,
            _intent: RTTI_Element_1.RTTI_Element,
            priority: RTTI_code_1.RTTI_code,
            _priority: RTTI_Element_1.RTTI_Element,
            doNotPerform: t.boolean,
            _doNotPerform: RTTI_Element_1.RTTI_Element,
            timingTiming: RTTI_Timing_1.RTTI_Timing,
            timingDateTime: t.string,
            _timingDateTime: RTTI_Element_1.RTTI_Element,
            timingAge: RTTI_Age_1.RTTI_Age,
            timingPeriod: RTTI_Period_1.RTTI_Period,
            timingRange: RTTI_Range_1.RTTI_Range,
            timingDuration: RTTI_Duration_1.RTTI_Duration,
            location: RTTI_Reference_1.RTTI_Reference,
            participant: t.array(RTTI_ActivityDefinition_Participant_1.RTTI_ActivityDefinition_Participant),
            productReference: RTTI_Reference_1.RTTI_Reference,
            productCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            quantity: RTTI_Quantity_1.RTTI_Quantity,
            dosage: t.array(RTTI_Dosage_1.RTTI_Dosage),
            bodySite: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            specimenRequirement: t.array(RTTI_Reference_1.RTTI_Reference),
            observationRequirement: t.array(RTTI_Reference_1.RTTI_Reference),
            observationResultRequirement: t.array(RTTI_Reference_1.RTTI_Reference),
            transform: RTTI_canonical_1.RTTI_canonical,
            dynamicValue: t.array(RTTI_ActivityDefinition_DynamicValue_1.RTTI_ActivityDefinition_DynamicValue)
        })
    ]);
});
//# sourceMappingURL=RTTI_ActivityDefinition.js.map